import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiFileTree } from '@lumapps/lumx/icons';
import { useSelector } from '@lumapps/redux/react';
import { useTranslate, GLOBAL } from '@lumapps/translations';

import { isWorkflowsAllowed } from '../../ducks/selectors';
import { workflowsRoute } from '../../routes';

export const WorkflowsSideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const isAllowed = useSelector(isWorkflowsAllowed);
    const { translateKey } = useTranslate();

    if (isAllowed) {
        return (
            <SideNavigationItem
                {...props}
                route={workflowsRoute}
                label={translateKey(GLOBAL.WORKFLOWS)}
                icon={mdiFileTree}
            />
        );
    }

    return null;
};

WorkflowsSideNavigation.displayName = 'SideNavigationItem';
